export default "__VITE_ASSET__DW9nCiK5__"